import { createSafeContext, NumberService } from '@mews/framework';
import { useCultureCode } from '@mews-commander/core';
import { PortfolioRateGroupOverview } from '@mews-commander/data-access';
import { getCurrentNumberCultureInfo, getCurrencyCultureInfo } from '@mews-commander/core/legacy-globalization';
import { useCommanderSelector } from '@mews-commander/utils';

export const useFormatPercent = () => {
    const numberCultureInfo = useCommanderSelector((state) => getCurrentNumberCultureInfo(state));

    return (value: number) => NumberService.formatPercent(value, numberCultureInfo);
};

export const useFormatCurrencyValue = () => {
    const cultureCode = useCultureCode();
    const currencyCultureInfo = useCommanderSelector((state) => getCurrencyCultureInfo(state, { cultureCode }));

    return (value: number) =>
        NumberService.formatCurrencyValue(value, currencyCultureInfo, { precision: 2, showSymbol: false });
};

export const { SelectedRateGroupsContextProvider, useSelectedRateGroupsContext } = createSafeContext<
    'SelectedRateGroupsContext',
    Array<PortfolioRateGroupOverview>
>('SelectedRateGroupsContext');
